// Dependencies
import React from "react";
import { connect } from "react-redux";
// Components
import { internalization } from "../../constants";

import ContentBlock from "../../components/contentBlock";
import Tooltip from "../../components/tooltip";
import Icon from "../../components/icons";
import StackHeader from "../../components/stackHeader";

import { withRouter } from '../../helpers/withRouter'

// Actions
import { getArticle, buttonClicked } from "../../actions/articles";

class ServicesShowScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            content: -1,
            showTabs: true,
            showTooltip: false,
            indexTooltip: "",
            title: ""
        }
    }

    componentDidMount() {
    let id;

    // Intenta tomar el id desde router.state
    id = this.props.router.location?.state?.id;

    // Si no existe, lo tomamos del path
    if(!id) {
        const pathSegments = this.props.router.location.pathname.split('/');
        id = pathSegments[pathSegments.length - 1];
    }

    console.log("Fetching article id:", id); // para debug

    // Solo hacemos fetch si hay id
    if(id) {
        this.props.getArticle(
            this.props.authentication_token,
            (responseJSON) => this._success(responseJSON),
            () => {},
            id
        );
    } else {
        console.error("No article id found to fetch!");
    }
}


    _success(responseJSON){
        console.log(responseJSON)
        this.setState({title: responseJSON.title})
        this._prepareBreadcrumb(responseJSON)
    }

   _prepareBreadcrumb(responseJSON) {
  const { router, menu } = this.props;

  // Determinar el idioma del usuario
  const languageUserAgent = (/^es/).test(this.props.user.language) ? 'es' : 'en';

  // Extraer current_id desde la URL
  let pathname = router.location.pathname;
  let current_id;
  let urlBase = '';
  if (pathname.includes("/services/")) {
    urlBase = "/services";
    current_id = pathname.split("/services/")[1];
  } else if (pathname.includes("/researchs/")) {
    urlBase = "/researchs";
    current_id = pathname.split("/researchs/")[1];
  }

  // Filtrar los servicios del menú
  const serviceArray = (menu.list || []).filter(el => el.code === "service");
  const service = serviceArray[1] || serviceArray[0] || null;

  // Seleccionar el artículo
  const article_selected = (responseJSON.articles || []).find(
    article => String(article.id) === String(current_id)
  );

  // Determinar título seguro
  let assetTitle = responseJSON.title; // default
  if (service && String(current_id) === String(service.navigation_id)) {
    assetTitle = responseJSON.title;
  } else if (article_selected) {
    assetTitle = article_selected.title || responseJSON.title;
  }

  // Llamar a getBreadcrumbs
  this.props.getBreadcrumbs({
    assetUrl: urlBase,
    url: urlBase,
    assetTitle
  });
}


    handleTooltip(e, index) {
        e.stopPropagation();
        this.setState({ showTooltip: !this.state.showTooltip, indexTooltip : index});
        let body = document.body;
        body.addEventListener('click', e => this.setState({ showTooltip: false }) );
    }

    _buttonClicked(item){
        
        if(item.action === "2"){
            window.open(item.url_download, '_blank');
        }
        else{
            this.props.buttonClicked(item.url, this.props.authentication_token, () => console.log("Ok"), () => console.log("KO"))    
        }
        
    }
    _changeTab(id){
        this.setState({ content: id });
        let article_selected = this.props.showArticle.filter((e) => e.id === id)
         this.props.getBreadcrumbs({
          assetUrl: '/services',
          url: '/services',
          assetTitle: article_selected[0].title
        });        
    }

    
    render() {

        let article_selected = this.state.content === -1 ? this.props.showArticle[0] :  this.props.showArticle.filter((e) => e.id === this.state.content)[0]
        console.log(article_selected)
        return (
            <div className="main-wrapper services">

                <StackHeader
                    title={this.state.title}
                    icon={<Icon name="LogoB" iconBig={true} />}
                    help={false}
                    helpAction={() => alert("boton de info del stackHeader")}
                />

                {
                    this.props.showArticle.length > 1 &&

                        <div className="wrapper-tabs">

                            {
                                this.props.showArticle && this.props.showArticle.length > 0 && this.props.showArticle.map((article, index) => {
                                    return(
                                        <button 
                                            type="button" 
                                            className={this.state.content === article.id || this.state.content === -1 && index == 0 ? "btn primary border" : "btn primary"}
                                            onClick={(e)=> {
                                              this._changeTab(article.id)
                                                
                                            }}
                                        >
                                            <span class="btn-text">{article.title}</span>
                                        </button>
                                    )
                                })
                            }                            

                        </div>
                }

                        <div className="super-wrapper-content-block froala">
                            <div className={Object.keys(this.props.showArticle).length > 0 && article_selected && article_selected.section_medium.html != "" && (article_selected.section_medium !== "" || article_selected.links.length > 0) ? "sixty-percent" : ""}>
                                <ContentBlock
                                    title={article_selected ? this.props.showArticle.length > 1 ?  article_selected && article_selected.section_large.subtitle_large : article_selected.title : ""}
                                    header={this.props.showArticle.length > 1 ? article_selected && article_selected.section_large.subtitle_large === "" ? false : true : true}
                                    maxHeight={false}
                                    className="fr-wrapper only-text"
                                    contentClass="fr-element fr-view"
                                    date={article_selected ? article_selected.published_date_section_large ? article_selected.published_date_section_large : article_selected.created_at : undefined}
                                    
                                >
                                  {
                                     Object.keys(this.props.showArticle).length > 0 && article_selected && article_selected.section_large !== undefined &&
                                    <div dangerouslySetInnerHTML={{ __html: article_selected.section_large.html }}></div>
                                  }
                                  <div className="centered">
                                        
                                        {
                                          Object.keys(this.props.showArticle).length > 0 && article_selected && article_selected.section_large !== undefined &&

                                          article_selected.section_large.buttons.map((item,index) => {
                                            return(
                                                <p className="tooltip-link" onClick={e => {this._buttonClicked(item); item.action !== "2" && this.handleTooltip(e, index)} }>
                                                  {item.text}

                                                {
                                                  (this.state.showTooltip && this.state.indexTooltip === index) &&
                                                    <Tooltip>
                                                      <span className="tooltip-text" dangerouslySetInnerHTML={{ __html: item.feedback }}></span>                                                        
                                                    </Tooltip>
                                                }
                                              </p>
                                            )
                                          })
                                        }
                                    </div>
                                  
                                
                                </ContentBlock>
                            </div>
                            {
                                Object.keys(this.props.showArticle).length > 0 && (article_selected || article_selected.section_medium !== undefined && article_selected.section_medium !== "" && article_selected.section_medium.html != "") &&

                            <div className="fourty-percent">
                                {
                                    article_selected.section_medium !== undefined && article_selected.section_medium !== "" && article_selected.section_medium.html != "" &&
                                    <ContentBlock
                                    title={article_selected && article_selected.section_medium.subtitle_medium === "" ? article_selected.texts.fund_manager : article_selected.section_medium.subtitle_medium}
                                    header={true}
                                    maxHeight={false}
                                    className="fr-wrapper only-text"
                                    contentClass="fr-element fr-view"
                                    date={article_selected ? article_selected.published_date_section_medium ? article_selected.published_date_section_medium : article_selected.created_at : undefined}
                                >
                                    <div dangerouslySetInnerHTML={{ __html: article_selected.section_medium.html }}></div>
                                    
                                    <div className="centered">
                                        
                                        {
                                          Object.keys(this.props.showArticle).length > 0 && article_selected && article_selected.section_medium !== undefined &&

                                          article_selected.section_medium.buttons.map((item,index) => {
                                            return(
                                                <p className="tooltip-link" onClick={e => {this._buttonClicked(item); item.action !== "2" && this.handleTooltip(e, index)} }>
                                                  {item.text}

                                                {
                                                  (this.state.showTooltip && this.state.indexTooltip === index) &&
                                                    <Tooltip>
                                                      <span className="tooltip-text" dangerouslySetInnerHTML={{ __html: item.feedback }}></span>
                                                      <span className="tooltip-text"> For more information please visit: <a href="https://bulltick.com" className="link" target='_blank'> https://bulltick.com</a></span>

                                                    </Tooltip>
                                                }
                                                </p>
                                            )
                                          })
                                        }
                                    </div>
                                </ContentBlock>
                                }
                                    
                                {
                                    article_selected.links !== undefined && article_selected.links.length > 0 &&
                                <ContentBlock
                                    title={article_selected && article_selected.texts.subtitle_files === "" ? article_selected.texts.fund_documents : article_selected.texts.subtitle_files}                                
                                    header={true}
                                    maxHeight={false}
                                    className="only-text"
                                    //date={article_selected ? article_selected.published_date_section_files ? article_selected.published_date_section_files : article_selected.created_at : undefined}
                                >
                                  {
                                    Object.keys(this.props.showArticle).length > 0 && article_selected && article_selected.links !== undefined &&

                                    article_selected.links.slice(0,3).map((item,index) => {
                                      return(
                                        <>
                                          <ul className="list">
                                            <li className="list-item"><a href={item.link} target="_blank" className="link" style={{marginBottom: 0}}><p style={{marginBottom: '5px'}} dangerouslySetInnerHTML={{ __html: item.text }}></p></a></li>
                                          </ul>
                                          <p className="date" style={{paddingLeft: '25px'}}>{item.published_date}</p>
                                        </>
                                        )
                                    })
                                    }
                                    {
                                        article_selected.links.length > 3 &&
                                        <button 
                                            type="button" 
                                            className={"btn primary border"}
                                            onClick={(e)=> {
                                                this.props.router.navigate("/services/"+article_selected.id+"/files",
                                                  {
                                                    state: {
                                                      id: article_selected.id
                                                    }
                                                  })
                                            }}
                                        >
                                            <span class={"btn-text"}>{article_selected.texts.read_more}</span>
                                        </button>
                                    }
                                    
                                </ContentBlock>

                                }
                            </div>
                            }                            


                        </div>
                
            </div>
        )
    }

}

function mapStateToProps(state) {
  return {
    showArticle: state.articles.showArticle,
    authentication_token: state.session.authentication_token,
    user: state.session.user,
    menu: state.session.menu,
    bulltick_research_id: state.session.bulltick_research_id
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getArticle: (authentication_token,success, error,id) => dispatch(getArticle(authentication_token,success, error,id)),
    buttonClicked: (url, authentication_token, success, error) => dispatch(buttonClicked(url, authentication_token, success, error))
  };
}


export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ServicesShowScreen));

